import type { DefaultValues, SubmitHandler } from 'react-hook-form';
import { useForm } from 'react-hook-form';

import type { IContentBlockFormBodyProps } from '~/components/molecules/ContentBlock';
import type { IFileUploaderValue } from '~/components/organisms/fields/FileUploader';
import type { IContainerProps } from '~/components/utils/Container';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { WPLeaderboardFormMainSection } from './WPLeaderboardFormMainSection';

export type IWPLeaderboardFormValues = {
  iapPollId?: string;
  defaultPictures?: Array<IFileUploaderValue>;
};

export type IWPLeaderboardFormProps = IContainerProps &
  Omit<
    IContentBlockFormBodyProps<IWPLeaderboardFormValues>,
    'form' | 'children' | 'onSubmit' | 'submitting'
  > & {
    defaultValues?: DefaultValues<IWPLeaderboardFormValues>;
    onSubmit?: SubmitHandler<IWPLeaderboardFormValues>;
    appId: string;
  };

export const WPLeaderboardForm: React.FC<IWPLeaderboardFormProps> = (props) => {
  const { defaultValues, appId, ...other } = props;

  const form = useForm<IWPLeaderboardFormValues>({
    defaultValues,
  });

  return (
    <ContentBlock.FormBody form={form} {...other}>
      <WPLeaderboardFormMainSection form={form} appId={appId} />
    </ContentBlock.FormBody>
  );
};
